@if (maxWidth()) {
<span class="block truncate" [style.max-width]="maxWidth()" [title]="tooltip() ? '' : text()" [attr.data-tooltip]="tooltip()">{{ text() }}</span>
} @else {
<span [attr.data-tooltip]="tooltip()">{{ text() }}</span>
}
